<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="4" offset-lg="7">
        <v-text-field
          v-model="buscaPreaspirante"
          rounded
          filled
          placeholder="Buscar preaspirante por nombre o CURP"
          append-icon="mdi-magnify"
          class="search-field"
        ></v-text-field>
      </v-col>
      <v-col lg="1">
        <v-btn-toggle v-model="ordenAlfabetico" class="toggle-buttons" rounded mandatory>
          <v-btn icon>
            <v-icon color="secondary darken-2">mdi-order-alphabetical-ascending</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon color="secondary darken-2">mdi-order-alphabetical-descending</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="buscaPreaspirante.length > 0">
        <div class="text-h6 font-weight-bold">
          {{ filteredPreaspirantes.length }} resultados encontrados con la búsqueda "{{ buscaPreaspirante }}"
        </div>
      </v-col>
      <v-expansion-panels flat class="modern-expansion" focusable hover mandatory>
        <v-expansion-panel v-for="(grupoPreaspirantes, index) in groupedPreaspirantes" :key="index">
          <v-expansion-panel-header class="expansion-header">
            <div>
              <div class="text-h6 header-letter font-weight-bold d-inline">
                {{ grupoPreaspirantes.inicial }}
              </div>
              <div class="text-overline d-inline header-count">({{ grupoPreaspirantes.preaspirantes.length }})</div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  lg="4"
                  xl="3"
                  v-for="preaspirante in grupoPreaspirantes.preaspirantes"
                  :key="preaspirante.id"
                >
                  <v-card class="preaspirante-card" elevation="8">
                    <v-card-title class="card-header">
                      <v-container>
                        <v-row>
                          <v-col cols="12" align="center">
                            <v-avatar rounded color="secondary" size="80">
                              <v-icon x-large color="white">mdi-account</v-icon>
                            </v-avatar>
                          </v-col>
                          <v-col cols="12" align="center">
                            <div class="text-h6 name-title font-weight-bold">{{ preaspirante.apaterno }}</div>
                            <div class="text-subtitle-1 name-subtitle">
                              {{ preaspirante.amaterno + ' ' + preaspirante.nombre + ' ' + preaspirante.segundoNombre }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-title>
                    <v-card-actions class="card-actions">
                      <v-container>
                        <v-row>
                          <v-col cols="12" align="right">
                            <v-tooltip
                              bottom
                              color="black"
                              v-if="hasAccessToFeature(perfil, FEATURES.CAPTURA_FOTOGRAFIA)"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="action-button"
                                  elevation="8"
                                  :to="{ name: 'capturaFoto', params: { id: preaspirante.idPersonal } }"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                  ><v-icon>mdi-camera</v-icon></v-btn
                                >
                              </template>
                              <span>Captura de fotografía</span>
                            </v-tooltip>
                            <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.CAPTURA_VOZ)">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="action-button"
                                  elevation="8"
                                  :to="{ name: 'capturaVoz', params: { id: preaspirante.idPersonal } }"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                  ><v-icon>mdi-microphone</v-icon></v-btn
                                >
                              </template>
                              <span>Captura de voz</span>
                            </v-tooltip>
                            <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.CAPTURA_HUELLAS)">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="action-button"
                                  elevation="8"
                                  :to="{ name: 'capturaHuella', params: { id: preaspirante.idPersonal } }"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                  ><v-icon>mdi-fingerprint</v-icon></v-btn
                                >
                              </template>
                              <span>Captura de huellas</span>
                            </v-tooltip>
                            <v-tooltip
                              bottom
                              color="black"
                              v-if="hasAccessToFeature(perfil, FEATURES.REGISTRO_RESULTADO_CONSULTA_PREVIA)"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="action-button"
                                  elevation="8"
                                  :to="{ name: 'generaDictamen', params: { id: preaspirante.idPersonal } }"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                  ><v-icon>mdi-file-plus</v-icon></v-btn
                                >
                              </template>
                              <span>Registro de resultado en consulta previa</span>
                            </v-tooltip>
                            <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.REGISTRO_CUIP)">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="action-button"
                                  elevation="8"
                                  :to="{ name: 'registroFotoCuip', params: { id: preaspirante.idPersonal } }"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                  ><v-icon>mdi-card-text</v-icon></v-btn
                                >
                              </template>
                              <span>Registro de CUIP</span>
                            </v-tooltip>
                            <v-tooltip bottom color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="action-button"
                                  elevation="8"
                                  :to="{ name: 'documentosPreaspiranteSite', params: { id: preaspirante.idPersonal } }"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                  ><v-icon>mdi-file-account</v-icon></v-btn
                                >
                              </template>
                              <span>Ver expediente</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>
<style scoped>
/* Search Field */
.search-field >>> .v-input__control .v-input__slot {
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

.search-field >>> .v-input__control .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  background: rgba(0, 0, 0, 0.4) !important;
}

.search-field >>> .v-input--is-focused .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb), 0.15) !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.search-field >>> input {
  color: #e0e0e0 !important;
}

.search-field >>> .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
}

/* Toggle Buttons */
.toggle-buttons {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 12px !important;
}

.toggle-buttons >>> .v-btn {
  border: none !important;
}

.toggle-buttons >>> .v-btn .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  transition: all 0.3s ease !important;
}

.toggle-buttons >>> .v-btn--active .v-icon {
  color: var(--v-secondary-base) !important;
  transform: scale(1.1);
}

/* Results Text */
.text-h6 {
  color: #e0e0e0 !important;
}

/* Expansion Panels */
.modern-expansion {
  background: transparent !important;
}

.modern-expansion >>> .v-expansion-panel {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 16px !important;
  margin-bottom: 16px !important;
  transition: all 0.3s ease !important;
}

.modern-expansion >>> .v-expansion-panel:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3) !important;
}

.expansion-header {
  background: rgba(0, 0, 0, 0.15) !important;
  border-radius: 16px 16px 0 0 !important;
}

.header-letter {
  color: var(--v-secondary-base) !important;
  font-size: 1.5rem !important;
}

.header-count {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  margin-left: 8px;
}

.modern-expansion >>> .v-expansion-panel-content__wrap {
  background: transparent !important;
  padding: 24px 16px !important;
}

/* Preaspirante Cards */
.preaspirante-card {
  background: rgba(var(--v-secondary-base-rgb), 0.15) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease !important;
  overflow: hidden;
}

.preaspirante-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(var(--v-secondary-base-rgb), 0.4) !important;
  border-color: var(--v-secondary-base) !important;
}

.card-header {
  padding: 20px 16px !important;
  background: rgba(0, 0, 0, 0.2) !important;
}

.name-title {
  color: #e0e0e0 !important;
  margin-top: 12px;
  letter-spacing: 0.5px;
}

.name-subtitle {
  color: rgba(224, 224, 224, 0.8) !important;
  margin-top: 4px;
}

.card-actions {
  background: rgba(0, 0, 0, 0.25) !important;
  padding: 16px !important;
  border-top: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
}

/* Action Buttons */
.action-button {
  background: rgba(var(--v-secondary-base-rgb), 0.2) !important;
  color: var(--v-secondary-base) !important;
  margin: 0 4px !important;
  transition: all 0.3s ease !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3) !important;
}

.action-button:hover {
  background: var(--v-secondary-base) !important;
  color: #ffffff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(var(--v-secondary-base-rgb), 0.5) !important;
}

.action-button >>> .v-icon {
  color: inherit !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(0, 0, 0, 0.9) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3) !important;
  border-radius: 8px !important;
  padding: 8px 12px !important;
  font-size: 0.875rem !important;
}

/* Avatar */
::v-deep .v-avatar {
  border: 2px solid rgba(var(--v-secondary-base-rgb), 0.5) !important;
  box-shadow: 0 4px 12px rgba(var(--v-secondary-base-rgb), 0.3) !important;
}

/* FAB */
.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb), 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.6);
}
</style>
<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  data() {
    return {
      buscaPreaspirante: '',
      ordenAlfabetico: 0,
    }
  },

  computed: {
    ...mapGetters('preaspirante', {
      preaspirantes: 'getPreaspirantes',
    }),

    ...mapGetters({
      perfil: 'getPerfil',
    }),

    filteredPreaspirantes: function () {
      return this.preaspirantes.filter((preaspirante) => {
        return (
          preaspirante.nombre.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0 ||
          preaspirante.segundoNombre.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0 ||
          preaspirante.apaterno.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0 ||
          preaspirante.amaterno.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0 ||
          this.getAge(preaspirante.fechaNacimiento) == this.buscaPreaspirante
          // (preaspirante.CatMunicipioRadica && preaspirante.CatMunicipioRadica.nombre.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0) ||
          // (preaspirante.CatMunicipioRadica &&
          //     preaspirante.CatMunicipioRadica.CatEstado.title.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0)
          // (preaspirante.CatMunicipioNacimiento &&
          //     preaspirante.CatMunicipioNacimiento.nombre.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0) ||
          // (preaspirante.CatMunicipioNacimiento &&
          //     preaspirante.CatMunicipioNacimiento.CatEstado.title.toLowerCase().indexOf(this.buscaPreaspirante.toLowerCase()) >= 0)
        )
      })
    },

    groupedPreaspirantes: function () {
      var result = _(this.filteredPreaspirantes)
        .groupBy((preaspirante) => preaspirante.apaterno[0].toUpperCase())
        .map((preaspirantes, inicial) => ({ inicial, preaspirantes }))
        .value()

      if (this.ordenAlfabetico == 0) {
        result.sort(function (a, b) {
          if (a.inicial < b.inicial) {
            return -1
          }
          if (a.inicial > b.inicial) {
            return 1
          }
          return 0
        })
      } else {
        result.sort(function (a, b) {
          if (a.inicial > b.inicial) {
            return -1
          }
          if (a.inicial < b.inicial) {
            return 1
          }
          return 0
        })
      }
      return result
    },
  },

  methods: {
    getFullName: function (preaspirante) {
      return (
        preaspirante.nombre +
        ' ' +
        preaspirante.segundoNombre +
        ' ' +
        preaspirante.apaterno +
        ' ' +
        preaspirante.amaterno
      )
    },
  },
}
</script>
